module.exports = __webpack_public_path__ + "static/jrc-81a4a95c6783fb2f76f6b335a96dffd6.jpg";